import React from 'react';
import { FeedbackQuestion } from '../../../types/feedback';

interface CheckboxQuestionProps {
  question: FeedbackQuestion;
  value: string[];
  onChange: (value: string[]) => void;
  error?: string;
}

const CheckboxQuestion: React.FC<CheckboxQuestionProps> = ({
  question,
  value,
  onChange,
  error
}) => {
  const handleChange = (option: string, checked: boolean) => {
    if (checked) {
      onChange([...value, option]);
    } else {
      onChange(value.filter(v => v !== option));
    }
  };

  return (
    <div className="question-container">
      <label className="question-label">
        {question.question}
        {/* Removed required asterisk - all fields are now optional */}
      </label>
      
      <div className="checkbox-group">
        {question.options?.map((option, index) => (
          <label key={index} className="checkbox-option">
            <input
              type="checkbox"
              checked={value.includes(option)}
              onChange={(e) => handleChange(option, e.target.checked)}
              className="checkbox-input"
            />
            <span className="checkbox-label">{option}</span>
          </label>
        ))}
      </div>
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default CheckboxQuestion;
